import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVineComponent } from './simple-icons-vine.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVineComponent ],
    exports:      [ SimpleIconsVineComponent ],
    bootstrap:    []
})
export class SimpleIconsVineModule {}
